import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../context/NotificationContext';

export default function ToastNotification() {
  const { notifications } = useNotifications();
  const navigate = useNavigate();

  // Get most recent notification
  const latestNotification = notifications.length > 0 ? notifications[0] : null;

  const [visible, setVisible] = React.useState(false);

  useEffect(() => {
    if (latestNotification) {
      setVisible(true);

      // Auto-hide after 5 seconds
      const timer = setTimeout(() => {
        setVisible(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [latestNotification]);

  if (!visible || !latestNotification) return null;

  const getToastColor = (type) => {
    const colors = {
      milestone: 'bg-purple-600 border-purple-700',
      recovery: 'bg-green-600 border-green-700',
      newToken: 'bg-blue-600 border-blue-700'
    };
    return colors[type] || 'bg-gray-600 border-gray-700';
  };

  const getIcon = (type) => {
    const icons = {
      milestone: '🎯',
      recovery: '📈',
      newToken: '🪙'
    };
    return icons[type] || '🔔';
  };

  const handleToastClick = () => {
    setVisible(false);

    // Navigate based on notification type
    if (latestNotification.type === 'milestone') {
      navigate('/milestones');
    } else if (latestNotification.type === 'recovery') {
      navigate('/recovery');
    } else if (latestNotification.type === 'newToken') {
      navigate('/tokens');
    }
  };

  return (
    <div className="fixed top-20 right-6 z-50 animate-slide-in">
      <div
        className={`${getToastColor(latestNotification.type)} text-white px-6 py-4 rounded-lg shadow-2xl border-l-4 max-w-md cursor-pointer hover:shadow-3xl transition-shadow`}
        onClick={handleToastClick}
      >
        <div className="flex items-start gap-3">
          <span className="text-3xl">{getIcon(latestNotification.type)}</span>
          <div className="flex-1">
            <h4 className="font-bold text-lg mb-1">
              {latestNotification.title}
            </h4>
            <p className="text-sm opacity-90 mb-2">
              {latestNotification.message}
            </p>
            <div className="flex gap-2">
              {latestNotification.dexScreenerUrl && (
                <a
                  href={latestNotification.dexScreenerUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  className="inline-block text-xs bg-white dark:bg-gray-800 text-gray-900 dark:text-white px-3 py-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700 font-medium"
                >
                  📊 View Chart
                </a>
              )}
              <button
                onClick={handleToastClick}
                className="inline-block text-xs bg-white dark:bg-gray-800 bg-opacity-20 text-white px-3 py-1 rounded hover:bg-opacity-30 font-medium"
              >
                {latestNotification.type === 'milestone' ? '🎯 View Milestones' :
                 latestNotification.type === 'recovery' ? '📈 View Recovery' :
                 '🪙 View Tokens'}
              </button>
            </div>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              setVisible(false);
            }}
            className="text-white hover:text-gray-200 text-xl"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}
